import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

export default function SearchAd({ type, id }) {
  useEffect(() => {
    googletag.cmd.push(() => {
      googletag.display(id);
    });
  }, [id]);

  return (
    <div className="advertisement-aside">
      <h6>Advertisement</h6>
      <div className={`adblock-${type}`} id={id} />
    </div>
  );
}

SearchAd.propTypes = {
  type: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
};
